module.exports = __webpack_public_path__ + "img/smoke11.08a747fa.png";